import script from "./ProductGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductGallery.vue?vue&type=script&setup=true&lang=ts"

import "./ProductGallery.vue?vue&type=style&index=0&id=4475868e&lang=css"

const __exports__ = script;

export default __exports__